<template>
  <el-card class="create-campaign create-campaign-machine" v-loading="loading">
    <div class="wrapper" id="guide-step5">
      <section class="panel mt-6" style="padding-bottom: 4px;">
        <div class="divider">
          <h3>{{ $t('messages.myCampaign.list12') }}</h3>
        </div>
        <div class="content-box">
          <div class="content-box-lists">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t(item.tipI18n)"
              placement="bottom"
              v-for="item in machineTypeData"
              :key="item.id"
            >
              <div
                :class="{'lists-item': true, 'itemActive': form.business_type === item.id}"
                @click="chooseBusiness(item.id)"
              >
                <img :src="require(`../../assets/img/${item.icon}.png`)" width="96" class="img" />
                <img src="../../assets/img/right-gou.png" class="img2" v-if="form.business_type === item.id" />
                <p>{{ $t(item.nameI18n) }}</p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </section>
      <section class="panel mt-6">
        <div class="divider">
          <h3 class="divider-tips basic-info">{{ $t('messages.createCampaign.create32') }}</h3>
        </div>
        <div class="tip-box tip-box2">{{ $t(`messages.createCampaignBrush.${brushTypeTips[form.business_type]}`) }}</div>
        <div class="content-box">
          <div class="form-container">
            <el-form
              ref="createCampaign"
              :model="form"
              :rules="rules"
              label-position="right"
              label-width="180px"
            >
              <el-row v-if="mode === 'detail' && id">
                <el-col>
                  <div class="status-box">
                    <div class="status-label">{{ $t('messages.myCampaign.list5') }}</div>
                    <div class="status-value">
                      {{ showLabel(status, asoGrowOption.asogrow_campaign_status) }}
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="mode === 'detail' && id">
                <el-col>
                  <el-form-item :label="$t('messages.myCampaign.list8')">
                    <el-input v-model="id" disabled class="formWidth"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item :label="$t('messages.createCampaignBrush.os')" prop="os" class="os-form-item">
                    <div class="os-card-list">
                      <div
                        v-for="item in osOptions"
                        :key="item.id"
                        :class="{'os-card': true, 'os-card-active': form.os === item.id}"
                        @click="form.os = item.id"
                      >
                        <img :src="require(`../../assets/img/${item.icon}.png`)" alt="" class="os-card-icon" />
                        <p>{{ item.label }}</p>
                        <img
                          src="../../assets/img/right-gou.png"
                          class="os-card-check"
                          v-if="form.os === item.id"
                        />
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item
                    :label="$t('messages.createCampaign.create54')"
                    prop="app_store_url"
                    style="margin-bottom: 22px;"
                  >
                    <el-select
                      v-model="form.app_store_url"
                      size="medium"
                      @change="handleChangeCountry(1)"
                      v-if="applications.length>0"
                      class="app-select-wrap formWidth"
                      @focus="setOptionWidth"
                      :placeholder="$t('messages.other.other54')"
                    >
                      <div slot="prefix" class="app-select-prefix-icon" v-if="selectObj.imgUrl">
                        <img :src="selectObj.imgUrl" alt="icon url" width="22px"/>
                      </div>
                      <el-option
                        v-for="(item, i) in applications"
                        :key="i"
                        :label="`${item.app_name}`"
                        :value="item.app_store_url"
                        class="app-select-option"
                        :style="{width:selectOptionWidth || 'auto'}"
                        @click.native="changeCountryOption(i)"
                      >
                        <img :src="item.icon_url" alt="icon url" class="img" loading="lazy"/>
                        <p class="name">{{item.app_name}}</p>
                      </el-option>
                    </el-select>
                    <div v-else class="add-new-app" @click="showAddApp">
                      <p>+</p>
                      <p>{{ $t('messages.createCampaign.create76') }}</p>
                    </div>
                    <div class="tip-message" v-if="applications.length>0">
                      {{ $t('messages.createCampaign.create8') }}
                      <span @click="showAddApp">{{ $t('messages.createCampaign.create55') }}</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create7')" prop="country" class="country-form">
                    <el-select
                      v-model="form.country"
                      size="medium"
                      class="formWidth"
                      @change="(val)=>handleChangeCountry(2,val)"
                      filterable
                      @focus="setOptionWidth"
                      :placeholder="$t('messages.other.other54')"
                    >
                      <el-option
                        v-for="(item, i) in countryOptionsCom"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                        :style="{width:selectOptionWidth || 'auto'}"
                        :disabled="countryDisabled(item.id)"
                      ></el-option>
                    </el-select>
                    <div class="tip-message">
                      {{ $t('messages.createCampaign.create9') }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isKeywordInstall">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaign.create13')" prop="schedule">
                    <el-date-picker
                      v-model="form.schedule"
                      type="daterange"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      :range-separator="$t('messages.other.other63')"
                      :start-placeholder="$t('messages.createCampaign.create161')"
                      :end-placeholder="$t('messages.createCampaign.create190')"
                      :picker-options="pickerOptions"
                      @change="changeTimeSchedule"
                      class="formWidth"
                      popper-class="popperClass"
                    ></el-date-picker>
                    <div class="tip-message">
                      {{ $t('messages.createCampaign.create14') }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isRankingType">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaignBrush.ranking')" prop="ranking">
                    <el-select
                      v-model="form.ranking"
                      class="formWidth"
                      :placeholder="$t('messages.other.other54')"
                    >
                      <el-option
                        v-for="item in rankingOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isGuaranteedKeywordRanking">
                <el-col>
                  <el-form-item :label="$t('messages.createCampaignBrush.promoteDays')" prop="promotion_option">
                    <el-select
                      v-model="form.promotion_option"
                      class="formWidth"
                      :placeholder="$t('messages.other.other54')"
                    >
                      <el-option
                        v-for="item in promoteDaysOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="isKeywordInstall">
              <div v-for="(item, index) in form.info" :key="index">
                <el-row
                  justify="space-between"
                  :gutter="16"
                  class="keywords-wrap"
                >
                  <el-col :span="20">
                    <el-form-item
                      :label="$t('messages.createCampaign.create91')"
                      :prop="`info.${index}.keyword`"
                      :rules="machineKeywordRules"
                      class="keyword-form"
                      style="margin-bottom: 22px;"
                    >
                      <el-input v-model="item.keyword"></el-input>
                      <div class="tip-message">
                        {{ $t('messages.createCampaignBrush.brush1') }}
                        <br />
                        {{ $t('messages.createCampaignBrush.brush2') }}
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" style="text-align: right;width: 10%;">
                    <template v-if="index === 0">
                      <el-button
                        type="primary"
                        @click="addKeyword(form.info)"
                        :disabled="form.info.length >= 20"
                      >
                        {{ $t('messages.createCampaign.create97') }}
                      </el-button>
                      <p
                        style="color: #f56c6c;font-size: 12px;margin-top: 8px;"
                        v-if="form.info.length >= 20"
                      >
                        {{ $t('messages.createCampaign.create98') }}
                      </p>
                    </template>
                    <el-button type="primary" @click="deleteKeyword(index, form.info)" v-else>
                      {{ $t('messages.home.tip54') }}
                    </el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item
                      :label="$t('messages.createCampaign.create21')"
                      :prop="`info.${index}.daily_cap`"
                      :rules="dailyCapRules"
                    >
                      <el-input-number
                        v-model="item.daily_cap"
                        :precision="0"
                        :controls="false"
                        @change="
                          value => {
                            changeDailyCap(value, item)
                          }
                        "
                      />
                      <div class="tip-message">
                        {{ $t('messages.createCampaign.create22') }}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item
                      :label="$t('messages.myCampaign.list21')"
                      :prop="`info.${index}.total_cap`"
                      :rules="totalCapRules"
                    >
                      <el-input-number
                        v-model="item.total_cap"
                        :precision="0"
                        :controls="false"
                        disabled
                        @change="
                          value => {
                            changeTotalCap(value,index)
                          }
                        "
                      />
                      <div class="tip-message">
                        {{ $t('messages.createCampaign.create23') }}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              </template>
              <el-row v-if="isGuaranteedKeywordRanking && mode !== 'detail'">
                <el-col>
                  <el-form-item
                    :label="$t('messages.createCampaignBrush.cap')"
                    prop="info.0.total_cap"
                    :rules="totalCapRules"
                  >
                    <el-input-number
                      v-model="form.info[0].total_cap"
                      :precision="0"
                      :controls="false"
                    />
                    <div class="tip-message">
                      {{ $t('messages.createCampaign.create22') }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item
                    :label="$t('messages.createCampaignBrush.contact')"
                    prop="contact_value"
                    class="application-number machine-contact"
                  >
                    <el-input
                      v-model="form.contact_value"
                      :placeholder="$t('messages.register.contact2')"
                      class="formWidth"
                    >
                      <el-select
                        v-model="form.contact_type"
                        slot="prepend"
                        :placeholder="$t('messages.other.other54')"
                        popper-class="app-select"
                        @change="changeContactType"
                        ref="contact_type"
                      >
                        <el-option
                          v-for="item in contactApplications"
                          :key="item.value"
                          :label="$t(item.i18n)"
                          :value="item.value"
                        >
                          <img
                            :src="item.src"
                            style="width: 16px;height: 16px;margin-right: 16px;vertical-align: -3px;"
                          />
                          <span>{{ $t(item.i18n) }}</span>
                        </el-option>
                      </el-select>
                    </el-input>
                    <div class="tip-message">
                      {{ $t('messages.createCampaignBrush.brush3') }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <section class="order-price">
              <div class="order-price-main">
                <div class="order-price-label">
                  {{ isAdvancePayment ? $t('messages.createCampaignBrush.brush6') : $t('messages.createCampaign.create24') }}
                </div>
                <div v-if="orderPriceCal" class="order-price-amount">{{ brushOrderPriceTip }}</div>
              </div>
              <div class="order-price-wrap" v-if="orderPriceCal && showOrderPriceTips">
                <div class="order-price-bottom order-price-bottom2">
                  <p v-if="isKeywordInstall">{{ $t('messages.createCampaignBrush.brush4') }}</p>
                  <p v-if="isIndustryListRanking">{{ $t('messages.createCampaignBrush.brush5') }}</p>
                  <template v-if="isGuaranteedKeywordRanking">
                    <p>{{ $t('messages.createCampaignBrush.brush7') }}</p>
                    <p>{{ $t('messages.createCampaignBrush.brush8') }}</p>
                  </template>
                </div>
              </div>
            </section>
            <section class="submit">
              <el-row justify="center" class="submit-row">
                <el-button
                  type="primary"
                  @click="validate"
                  :disabled="mode === 'detail' && status !== 3"
                  class="mr-6"
                >
                  {{ showBrushBtnText() }}
                </el-button>
                <el-button @click="backToList">{{ $t('messages.createCampaign.create109') }}</el-button>
              </el-row>
            </section>
          </div>
        </div>
      </section>
    </div>
    <el-dialog
      class="campaign-confirm"
      :title="$t('messages.myCampaign.list38')"
      :visible.sync="confirmVisible"
      width="645px"
    >
      <div class="campaign-info">
        <div class="row" v-if="false">
          <div class="label">{{ $t('messages.myCampaign.list19') }}:</div>
          <div class="value">
            <img :src="form.icon" alt="icon" width="32" height="32" />
          </div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list11') }}:</div>
          <div class="value">{{ form.app_name }}</div>
        </div>
        <div class="row" v-if="isKeywordInstall">
          <div class="label">{{ $t('messages.myCampaign.list14') }}:</div>
          <div>
            <div class="value">
              <span style="color:#ffa922;display:inline-block;">{{ form.schedule?form.schedule[0]:'' }}</span>
              <span> – {{ form.schedule?form.schedule[1]:'' }}</span>
            </div>
            <p class="tip-p" v-if="confirmVisible">
              {{
                rightNow
                  ? `(${$t('messages.other.other38')})`
                  : `(${$t('messages.myCampaign.list39')} ${form.schedule?form.schedule[0]:''} 07:00:00 (${getTimeZ(
                      form.tz
                    )}) ${$t('messages.myCampaign.list40')})`
              }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.myCampaign.list12') }}:</div>
          <div class="value">{{ machineTypeName }}</div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.createCampaignBrush.os') }}:</div>
          <div class="value">{{ osLabel }}</div>
        </div>
        <div class="row" v-if="isRankingType">
          <div class="label">{{ $t('messages.createCampaignBrush.ranking') }}:</div>
          <div class="value">{{ rankingLabel }}</div>
        </div>
        <div class="row" v-if="isGuaranteedKeywordRanking">
          <div class="label">{{ $t('messages.createCampaignBrush.promoteDays') }}:</div>
          <div class="value">{{ promoteDaysLabel }}</div>
        </div>
        <div class="row">
          <div class="label">{{ $t('messages.createCampaignBrush.contact') }}:</div>
          <div class="value">{{ contactLabel }}</div>
        </div>
        <div class="row" v-if="isKeywordInstall">
          <div class="label">{{ $t('messages.myCampaign.list21') }}:</div>
          <div class="value">{{ sumTotalCap }}</div>
        </div>
        <div class="row" v-if="isGuaranteedKeywordRanking && mode !== 'detail'">
          <div class="label">{{ $t('messages.createCampaignBrush.cap') }}:</div>
          <div class="value">{{ form.info[0] && form.info[0].total_cap }}</div>
        </div>
        <div class="row" v-if="orderPriceCal">
          <div class="label">
            {{ isAdvancePayment ? $t('messages.createCampaignBrush.brush6') : $t('messages.myCampaign.list22') }}:
          </div>
          <div class="value" style="color: #f56c6c;font-weight: bold;">{{ brushOrderPriceTip }}</div>
        </div>
      </div>
      <div class="balance-tips" v-if="!balanceNotEnough">
        <p>{{ $t('messages.createCampaign.create51') }}</p>
      </div>
      <div class="balance-tips" v-if="balanceNotEnough">
        <p>{{ $t('messages.createCampaign.create194') }} <span style="color: #f56c6c;">
          {{ $t('messages.createCampaign.create195') }}{{ orderPriceCal2 }} {{ $t('messages.createCampaign.create197') }}</span>
        </p>
        <p>{{ $t('messages.createCampaign.create89') }}</p>
      </div>
      <div class="footer" slot="footer">
        <el-button
          type="primary"
          @click="create"
          v-if="!balanceNotEnough"
          :loading="createButtonLoading"
        >
          {{ $t('messages.myCampaign.list27') }}
        </el-button>
        <el-button type="primary" @click="goDeposit" v-if="balanceNotEnough">
          {{ $t('messages.myCampaign.list28') }}
        </el-button>
        <el-button
          type="text"
          @click="payItLater"
          v-if="balanceNotEnough"
          :loading="payLaterButtonLoading"
        >
          {{ $t('messages.myCampaign.list54') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-success" :title="$t('messages.createCampaign.create155')" :visible.sync="successVisible" width="600px">
      <div class="success-content">
        <p class="icon-success-box">
          <i class="iconfont icon-circle-check"></i>
        </p>
        <p class="success-text">
          {{ $t('messages.myCampaign.list29') }}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="viewCampaignList">{{ $t('messages.myCampaign.list30') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog class="create-fail" :title="$t('messages.deposit.deposit56')" :visible.sync="failVisible" width="600px">
      <div class="fail-content">
        <p class="icon-fail-box">
          <i class="iconfont icon-circle-close"></i>
        </p>
        <p class="fail-text">{{ $t('messages.myCampaign.list31') }}</p>
        <p class="fail-text">
          {{ $t('messages.myCampaign.list32') }}
        </p>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="failVisible = false">{{ $t('messages.myCampaign.list53') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog class="create-success" :title="$t('messages.createCampaign.create76')" :visible.sync="addAppVisible" width="530px">
      <div>
        <add-app-com
          @callback="handleCB"
          type="pop"
          :btnText="$t('messages.createCampaign.create97')"
          :store-name="form.os"
        ></add-app-com>
      </div>
    </el-dialog>
    <el-dialog class="create-success" :visible.sync="previewVisible" width="350px">
      <preview-img
        :iconFileList="iconFileList"
        :imgFileList="imgFileList"
        :hideIconUpload="hideIconUpload"
        :hideProductImgUpload="hideProductImgUpload"
        :form="form"
        type="pop"
      ></preview-img>
    </el-dialog>
    <div class="preview-container-btn" @click="previewVisible=true">
      <p>{{ $t('messages.createCampaign.create183') }}</p>
      <img src="../../assets/img/preview-r.png" alt="preview" width="16px"/>
    </div>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { funCalc } from '@common/js/common'
import { countrySupport, countrySupportCN } from '@/js/varible'
import campaignRules from '../../mixins/campaignCreate'
import addAppCom from '../../components/addAppCom.vue'
import previewImg from './component/previewImg.vue'

const OS_GOOGLE_PLAY = 'Google Play'
const OS_APP_STORE_IPHONE = 'App Store on IPhone'
const OS_APP_STORE_IPAD = 'App Store on IPAD'
const OS_PRICE_MAP = {
  android: 0.12,
  iphone: 0.1,
  ipad: 0.2,
  [OS_GOOGLE_PLAY]: 0.12,
  [OS_APP_STORE_IPHONE]: 0.1,
  [OS_APP_STORE_IPAD]: 0.2,
}
const OS_SUBMIT_MAP = {
  android: OS_GOOGLE_PLAY,
  iphone: OS_APP_STORE_IPHONE,
  ipad: OS_APP_STORE_IPAD,
  [OS_GOOGLE_PLAY]: OS_GOOGLE_PLAY,
  [OS_APP_STORE_IPHONE]: OS_APP_STORE_IPHONE,
  [OS_APP_STORE_IPAD]: OS_APP_STORE_IPAD,
}
const CONTACT_SUBMIT_MAP = {
  WhatsApp: 'WhatsAPP',
  WhatsAPP: 'WhatsAPP',
  Teams: 'Teams',
  Telegram: 'Telegram',
  WeChat: 'Wechat',
  Wechat: 'Wechat',
}

export default {
  components: {
    addAppCom,
    previewImg,
  },
  mixins: [campaignRules],
  data() {
    return {
      brushTypeTips:{
        30: 'contentInfo1',
        31: 'contentInfo2',
        32: 'contentInfo3',
      },
      machineTypeData: [
        {
          id: 30,
          icon: 'keyword-install',
          nameI18n: 'messages.createCampaign.create2',
          tipI18n: 'messages.createCampaignBrush.contentTip1'
        },
        {
          id: 31,
          icon: 'indu_list_rank',
          nameI18n: 'messages.createCampaignBrush.typeIndustryListRanking',
          tipI18n: 'messages.createCampaignBrush.contentTip2'
        },
        {
          id: 32,
          icon: 'gu_keyword_rank',
          nameI18n: 'messages.createCampaignBrush.typeGuaranteedKeywordRanking',
          tipI18n: 'messages.createCampaignBrush.contentTip3'
        },
      ],
      contactApplications: [
        { i18n: 'messages.profile.profile7', value: 'WhatsAPP', src: require('../../assets/img/WhatsApp.png') },
        { i18n: 'messages.createCampaignBrush.teams', value: 'Teams', src: require('../../assets/img/Teams.png') },
        { i18n: 'messages.profile.profile6', value: 'Telegram', src: require('../../assets/img/Telegram.png') },
        { i18n: 'messages.profile.profile5', value: 'Wechat', src: require('../../assets/img/WeChat.png') },
      ],
      appListCache: {},
      skipOsAppReset: false,
      form: {
        os: OS_GOOGLE_PLAY,
        ranking: '',
        promotion_option: '',
        contact_type: 'WhatsAPP',
        contact_value: '',
      },
      rules: {
        os: [
          this.createRequiredRule(this, 'messages.login.emptyErr'),
        ],
        ranking: [
          this.createRequiredRule(this, 'messages.login.emptyErr'),
        ],
        promotion_option: [
          this.createRequiredRule(this, 'messages.login.emptyErr'),
        ],
        contact_value: [
          this.createRequiredRule(this, 'messages.login.emptyErr'),
        ],
      },
      machineKeywordRules: [
        this.createRequiredRule(this, 'messages.login.emptyErr'),
        {
          validator: (rule, value, callback) => {
            let arr = rule.field.split('.')
            let index = 0
            if (arr.length > 1) {
              index = Number(arr[1])
            }
            // eslint-disable-next-line no-useless-escape
            let pattern = /[,，;；。.\、/]/
            if (pattern.test(value)) {
              /* eslint-disable standard/no-callback-literal */
              callback(new Error(this.$t('messages.createCampaign.create131')))
              return
            }
            let flag = this.form.info.some((row, i) => row.keyword === value && i !== index)
            if (flag) {
              /* eslint-disable standard/no-callback-literal */
              callback(new Error(this.$t('messages.createCampaign.create130')))
              return
            }
            callback()
          },
          trigger: 'blur',
        },
      ],
    }
  },
  computed: {
    isCombo() {
      return false
    },
    scheduleDays() {
      const { schedule } = this.form
      if (schedule && schedule[0] && schedule[1]) {
        const scheduleDay = dayjs(schedule[1]).diff(schedule[0], 'day', true)
        return Math.ceil(scheduleDay) + 1
      }
      return 1
    },
    osGooglePlay() {
      return OS_GOOGLE_PLAY
    },
    osAppStoreIPhone() {
      return OS_APP_STORE_IPHONE
    },
    osAppStoreIPad() {
      return OS_APP_STORE_IPAD
    },
    isGooglePlayOs() {
      return this.form.os === this.osGooglePlay
    },
    isAppleOs() {
      return this.form.os === this.osAppStoreIPhone || this.form.os === this.osAppStoreIPad
    },
    applicationsOsParam() {
      return this.isGooglePlayOs ? 2 : 1
    },
    allOsOptions() {
      return [
        { id: this.osGooglePlay, label: this.$t('messages.createCampaignBrush.googlePlay'), icon: 'google_play' },
        { id: this.osAppStoreIPhone, label: this.$t('messages.createCampaignBrush.appStoreIPhone'), icon: 'app_store' },
        { id: this.osAppStoreIPad, label: this.$t('messages.createCampaignBrush.appStoreIPad'), icon: 'app_store' },
      ]
    },
    osOptions() {
      if (this.isIndustryListRanking) {
        return this.allOsOptions.filter(item => item.id === this.osAppStoreIPhone)
      }
      return this.allOsOptions
    },
    rankingOptions() {
      if (this.isIndustryListRanking) {
        return [
          { id: 'Top1-3', label: this.$t('messages.createCampaignBrush.top1To3') },
          { id: 'Top4-6', label: this.$t('messages.createCampaignBrush.top4To6') },
          { id: 'Top7-12', label: this.$t('messages.createCampaignBrush.top7To12') },
          { id: 'Top13-25', label: this.$t('messages.createCampaignBrush.top13To25') },
          { id: 'Top26-35', label: this.$t('messages.createCampaignBrush.top26To35') },
          { id: 'Top36-50', label: this.$t('messages.createCampaignBrush.top36To50') },
        ]
      }
      if (this.isGuaranteedKeywordRanking) {
        return [
          { id: 'Top1', label: this.$t('messages.createCampaignBrush.top1') },
          { id: 'Top2', label: this.$t('messages.createCampaignBrush.top2') },
          { id: 'Top3', label: this.$t('messages.createCampaignBrush.top3') },
        ]
      }
      return []
    },
    promoteDaysOptions() {
      return [
        { id: '2 weeks', label: this.$t('messages.createCampaignBrush.weeks2') },
        { id: '3 weeks', label: this.$t('messages.createCampaignBrush.weeks3') },
        { id: 'More', label: this.$t('messages.createCampaignBrush.more') },
      ]
    },
    machineTypeName() {
      const item = this.machineTypeData.find(i => i.id === this.form.business_type)
      return item ? this.$t(item.nameI18n) : ''
    },
    osLabel() {
      const item = this.allOsOptions.find(i => i.id === this.form.os)
      return item ? item.label : ''
    },
    rankingLabel() {
      const item = this.rankingOptions.find(i => i.id === this.form.ranking)
      return item ? item.label : this.form.ranking
    },
    promoteDaysLabel() {
      const item = this.promoteDaysOptions.find(i => i.id === this.form.promotion_option)
      return item ? item.label : this.form.promotion_option
    },
    contactLabel() {
      const item = this.contactApplications.find(i => i.value === this.form.contact_type)
      const typeName = item ? this.$t(item.i18n) : this.form.contact_type
      return typeName ? `${typeName} ${this.form.contact_value}` : this.form.contact_value
    },
    allCountryOptions() {
      if (this.isEnglish) {
        return this.initSelectOptions(countrySupport)
      }
      return this.initSelectOptions(countrySupportCN)
    },
    countryOptionsCom() {
      const { os } = this.form
      const allCountries = this.allCountryOptions
      if (this.isAdvancePayment) {
        return allCountries
      }
      if (this.isWideCountryOs(os)) {
        return allCountries
      }
      return allCountries.filter(item => this.originalCountry.includes(item.id))
    },
    isKeywordInstall() {
      return this.form.business_type === 30
    },
    isIndustryListRanking() {
      return this.form.business_type === 31
    },
    isGuaranteedKeywordRanking() {
      return this.form.business_type === 32
    },
    isRankingType() {
      return this.isIndustryListRanking || this.isGuaranteedKeywordRanking
    },
    isAdvancePayment() {
      return this.isRankingType
    },
    showOrderPriceTips() {
      return this.isKeywordInstall || this.isAdvancePayment
    },
    brushUnitPrice() {
      return OS_PRICE_MAP[this.form.os] || 0
    },
    brushOrderPriceTip() {
      if (this.isAdvancePayment) {
        return '$300'
      }
      if (this.isKeywordInstall && this.sumTotalCap && this.brushUnitPrice) {
        return `$${this.brushUnitPrice} * ${this.sumTotalCap} = $${this.orderPriceCal2}`
      }
      return ''
    },
    orderPrice() {
      return {
        business_type: this.form.business_type,
        country: this.form.country,
        info: this.form.info,
        os: this.form.os,
      }
    },
  },
  watch: {
    'form.os'(newVal, oldVal) {
      const mapped = OS_SUBMIT_MAP[newVal]
      if (mapped && mapped !== newVal) {
        this.form.os = mapped
        return
      }
      this.resetCountryIfInvalid(newVal, this.form.business_type)
      if (!oldVal) {
        return
      }
      const prevOs = OS_SUBMIT_MAP[oldVal] || oldVal
      const nextOs = mapped || newVal
      if (this.getApplicationsOsParam(prevOs) !== this.getApplicationsOsParam(nextOs)) {
        if (!this.skipOsAppReset) {
          this.form.app_store_url = ''
          this.selectObj.imgUrl = ''
        }
        this.restoreAppListByOs()
      }
    },
    'form.contact_type'(newVal) {
      const mapped = CONTACT_SUBMIT_MAP[newVal]
      if (mapped && mapped !== newVal) {
        this.form.contact_type = mapped
      }
    },
    'form.business_type'(newVal) {
      this.syncOsByBusinessType(newVal)
      this.syncRankingByBusinessType()
      this.resetCountryIfInvalid(this.form.os, newVal)
    },
  },
  created() {
    this.freeTrial = false
    this.form.cp_type = 0
    this.form.os = OS_GOOGLE_PLAY
    this.form.contact_type = 'WhatsAPP'
    if (![30, 31, 32].includes(this.form.business_type)) {
      this.form.business_type = 30
    }
    this.syncOsByBusinessType(this.form.business_type)
    if (this.$route.query.type === 'detail' || this.$route.query.type === 'repeat') {
      this.skipOsAppReset = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.changeContactType(this.form.contact_type)
    })
  },
  methods: {
    getCampaignListPath() {
      return '/campaign/brush-list'
    },
    getAppListParams() {
      return { os: this.applicationsOsParam }
    },
    getApplicationsOsParam(os) {
      return os === this.osGooglePlay || os === 'android' ? 2 : 1
    },
    restoreAppListByOs() {
      const osKey = String(this.applicationsOsParam)
      if (this.appListCache[osKey]) {
        this.applications = this.appListCache[osKey]
        this.syncSelectedAppDisplay()
        this.skipOsAppReset = false
        return
      }
      this.getAppList()
    },
    getAppList(action) {
      const osKey = String(this.applicationsOsParam)
      const forceRefresh = action === 'change' || action === 'repeat'
      if (!forceRefresh && this.appListCache[osKey]) {
        this.applications = this.appListCache[osKey]
        this.applyAppListAction(action)
        return
      }
      this.$http
        .get('/api/applications/', {
          params: this.getAppListParams(),
        })
        .then(res => {
          const list = (res.data && res.data.applications) || []
          this.$set(this.appListCache, osKey, list)
          this.applications = list
          this.applyAppListAction(action)
        })
        .catch(() => {})
    },
    applyAppListAction(action) {
      let paramUrl = action === 'repeat' ? this.form.app_store_url : this.$route.query.url
      if (paramUrl) {
        const arr = this.applications.filter(i => i.app_store_url === paramUrl)
        if (arr.length > 0) {
          const obj = arr[0]
          this.aiForm.app_id = obj.id
          this.selectObj.imgUrl = obj.icon_url
          this.selectObj.country = obj.country
          this.selectObj.name = obj.app_name
          this.form.icon = obj.icon_url
          this.form.country = obj.country
          this.form.app_name = obj.app_name
          this.form.app_store_url = obj.app_store_url
          this.form.package = obj.package
          this.initOneImage(obj.icon_url, 'iconFileList')
        }
      }
      if (action === 'change' && this.applications[0]) {
        const obj = this.applications[0]
        this.aiForm.app_id = obj.id
        this.selectObj.imgUrl = obj.icon_url
        this.selectObj.country = obj.country
        this.selectObj.name = obj.name || obj.app_name
        this.form.country = obj.country
        this.form.icon = obj.icon_url
        this.form.app_name = obj.name || obj.app_name
        this.form.app_store_url = obj.app_store_url
        this.form.package = obj.package
        this.initOneImage(obj.icon_url, 'iconFileList')
      } else {
        this.syncSelectedAppDisplay()
      }
      this.skipOsAppReset = false
    },
    normalizeAppUrl(url) {
      return String(url || '').split('?')[0].replace(/\/$/, '')
    },
    findApplication(url) {
      if (!this.applications || !this.applications.length) {
        return null
      }
      let current = this.applications.find(item => item.app_store_url === url)
      if (current) {
        return current
      }
      const base = this.normalizeAppUrl(url)
      current = this.applications.find(item => this.normalizeAppUrl(item.app_store_url) === base)
      if (current) {
        return current
      }
      if (this.form.package) {
        current = this.applications.find(item => item.package === this.form.package)
      }
      return current || null
    },
    syncSelectedAppDisplay() {
      const current = this.findApplication(this.form.app_store_url)
      if (!current) {
        if (this.form.icon) {
          this.selectObj.imgUrl = this.form.icon
        }
        return
      }
      this.applyApplicationToForm(current)
    },
    applyApplicationToForm(current) {
      this.selectObj.imgUrl = current.icon_url || this.form.icon
      this.selectObj.country = current.country
      this.selectObj.name = current.app_name || current.name
      this.form.app_name = current.app_name || current.name || this.form.app_name
      this.form.icon = current.icon_url || this.form.icon
      this.form.package = current.package || this.form.package
      if (current.country) {
        this.form.country = current.country
      }
      if (current.app_store_url && this.form.app_store_url !== current.app_store_url) {
        this.form.app_store_url = current.app_store_url
      }
      this.initOneImage(this.form.icon, 'iconFileList')
    },
    applySelectedApplication() {
      const current = this.findApplication(this.form.app_store_url)
      if (!current) {
        return
      }
      this.applyApplicationToForm(current)
    },
    changeAppStoreUrl(value, type) {
      if (this.isAppleOs || !value) {
        this.syncSelectedAppDisplay()
        return
      }
      campaignRules.methods.changeAppStoreUrl.call(this, value, type)
    },
    handleChangeCountry(type, val) {
      if (this.isAppleOs) {
        if (type === 2 && val) {
          this.$set(this.form, 'country', val)
        }
        if (type === 1) {
          this.applySelectedApplication()
        }
        return
      }
      campaignRules.methods.handleChangeCountry.call(this, type, val)
    },
    syncOsByBusinessType(businessType) {
      if (businessType === 31 && this.form.os !== this.osAppStoreIPhone) {
        this.form.os = this.osAppStoreIPhone
      }
    },
    syncRankingByBusinessType() {
      if (!this.isRankingType) {
        this.form.ranking = ''
        return
      }
      const valid = this.rankingOptions.some(item => item.id === this.form.ranking)
      if (!valid) {
        this.form.ranking = ''
      }
    },
    isWideCountryOs(os) {
      return os === 'android' || os === 'iphone' || os === this.osGooglePlay || os === this.osAppStoreIPhone
    },
    toSubmitOs() {
      return OS_SUBMIT_MAP[this.form.os] || this.form.os
    },
    toSubmitContactType() {
      return CONTACT_SUBMIT_MAP[this.form.contact_type] || this.form.contact_type
    },
    resetCountryIfInvalid(os, businessType) {
      const { country } = this.form
      if (!country) {
        return
      }
      const useAllCountries = [31, 32].includes(businessType) || this.isWideCountryOs(os)
      if (!useAllCountries && !this.originalCountry.includes(country)) {
        this.form.country = ''
      }
    },
    calculateOrderPrice(value) {
      const { business_type, os, info } = value
      if (business_type === 31 || business_type === 32) {
        this.orderPriceCal = 300
        this.orderPriceCal2 = '300.00'
        return
      }
      if (business_type === 30) {
        let totalCap = 0
        info.forEach(item => {
          totalCap += item.total_cap || 0
        })
        const price = OS_PRICE_MAP[os]
        if (price && totalCap) {
          this.orderPriceCal = funCalc([totalCap, price], 2)
          this.orderPriceCal2 = Number(this.orderPriceCal).toFixed(2)
        } else {
          this.orderPriceCal = 0
          this.orderPriceCal2 = '0.00'
        }
        return
      }
      this.orderPriceCal = 0
      this.orderPriceCal2 = '0.00'
    },
    chooseBusiness(type) {
      const keepInfo = [30, 31, 32].includes(type) && [30, 31, 32].includes(this.form.business_type)
        ? JSON.parse(JSON.stringify(this.form.info))
        : null
      campaignRules.methods.chooseBusiness.call(this, type)
      if (keepInfo) {
        this.$nextTick(() => {
          this.form.info = keepInfo
        })
      }
    },
    showBrushBtnText() {
      if (this.mode === 'repeat') {
        return this.$t('messages.myCampaign.list1')
      }
      return this.$t('messages.myCampaign.list55')
    },
    changeContactType(value) {
      const current = this.contactApplications.find(item => item.value === value)
      if (!current || !this.$refs.contact_type) {
        return
      }
      this.$refs.contact_type.$el.children[0].setAttribute(
        'style',
        `background: url(${current.src}) no-repeat; background-size: 16px;background-position: 9px center;`
      )
    },
    getCheckParams() {
      const params = campaignRules.methods.getCheckParams.call(this)
      params.os = this.toSubmitOs()
      return params
    },
    generateParams() {
      const originSchedule = this.form.schedule
      const hasSchedule = this.form.schedule && this.form.schedule[0] && this.form.schedule[1]
      if (!hasSchedule) {
        this.form.schedule = ['', '']
      }
      const params = campaignRules.methods.generateParams.call(this)
      this.form.schedule = originSchedule
      const info = this.form.info.map(item => {
        const { samplePictureFileList, hideSamplePictureUpload, ...newItem } = item
        return newItem
      })
      params.info = JSON.stringify(info)
      params.os = this.toSubmitOs()
      params.contact_type = this.toSubmitContactType()
      params.contact_value = this.form.contact_value
      params.app_store_url = this.form.app_store_url
      params.country = this.form.country
      params.business_type = this.form.business_type
      params.cp_type = this.form.cp_type
      if (this.isRankingType) {
        params.ranking = this.form.ranking
        if (!hasSchedule) {
          delete params.start
          delete params.end
        }
      } else {
        delete params.ranking
      }
      if (this.isGuaranteedKeywordRanking) {
        params.promotion_option = this.form.promotion_option
      } else {
        delete params.promotion_option
      }
      delete params.contact_number
      delete params.promote_days
      delete params.review_helpfulness_vote
      delete params.tz
      delete params.post_banner
      delete params.avatar
      delete params.review_url
      delete params.review_name
      delete params.review_screenshot
      delete params.custom_review
      delete params.media_platform
      delete params.media_target
      delete params.comments_file
      delete params.campaign_new_user
      delete params.reviewer_name
      delete params.developer_name
      return params
    },
  },
}
</script>

<style lang="scss">
@import './campaignCreate.scss';
.create-campaign-machine {
  .content-box {
    align-items: flex-start;
  }
  .form-container {
    .el-form-item {
      margin-bottom: 22px;
    }
    .el-form-item__error {
      position: static;
      display: block;
      padding-top: 4px;
      line-height: 18px;
      white-space: normal;
      word-break: break-word;
    }
    .submit {
      margin-top: 24px;
    }
  }
  .content-box-lists .lists-item > p {
    height: auto;
    min-height: 20px;
    max-width: 96px;
    white-space: normal;
    line-height: 16px;
    word-break: break-word;
  }
  .os-form-item.el-form-item {
    display: flex;
    align-items: flex-start;
    &::before,
    &::after {
      display: none;
      content: none;
    }
    .el-form-item__label {
      float: none;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
      height: 64px;
      line-height: 22px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
    }
    .el-form-item__content {
      flex: 1;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      margin-left: 0 !important;
      line-height: 22px;
    }
  }
  .os-card-list {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 12px;
  }
  .os-card {
    position: relative;
    width: 88px;
    min-height: 64px;
    padding: 8px 6px 6px;
    border: 1px solid #e1e4eb;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .os-card-icon {
      width: 24px;
      height: 24px;
      display: block;
      margin-bottom: 4px;
    }
    p {
      margin: 0;
      font-size: 12px;
      line-height: 16px;
      color: #606266;
      text-align: center;
      word-break: break-word;
    }
    .os-card-check {
      position: absolute;
      right: 0;
      top: 0;
      width: 16px;
      height: 16px;
    }
    &:hover,
    &.os-card-active {
      border-color: rgba(24, 97, 242, 0.75);
      p {
        color: #1861f2;
      }
    }
  }
  .order-price {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    .order-price-main {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
    .order-price-label {
      width: 180px !important;
      min-width: 180px;
      box-sizing: border-box;
      padding: 0 12px 0 0;
      margin-right: 0;
      text-align: right;
      white-space: nowrap;
      line-height: 22px;
    }
    .order-price-amount {
      font-weight: bold;
      line-height: 22px;
    }
    .order-price-wrap {
      margin-top: 8px;
      padding-left: 180px;
    }
  }
  .machine-contact {
    .el-select {
      .el-input {
        background-repeat: no-repeat;
        background-size: 16px;
        background-position: 9px center;
      }
      .el-input__inner {
        text-indent: 20px;
        border-color: transparent !important;
      }
      .el-input__icon.el-input__validateIcon {
        display: none;
        color: transparent !important;
      }
    }
    .el-input-group__prepend {
      .el-input {
        width: 142px;
      }
    }
  }
}

@media screen and (max-width: 1025px) {
  .create-campaign-machine {
    .os-form-item.el-form-item {
      align-items: flex-start;
      flex-direction: column;
      .el-form-item__label {
        justify-content: flex-start !important;
        text-align: left !important;
        width: 100% !important;
        height: auto;
        padding: 0 !important;
      }
      .el-form-item__content {
        justify-content: flex-start;
        width: 100%;
      }
    }
    .os-card-list {
      width: 100%;
    }
    .order-price {
      .order-price-main {
        flex-wrap: wrap;
        column-gap: 12px;
        row-gap: 8px;
      }
      .order-price-label {
        width: auto !important;
        min-width: 0;
        padding: 0;
        text-align: left;
      }
      .order-price-wrap {
        padding-left: 0;
      }
    }
  }
}
</style>
